const styles = {
  container: {
    maxWidth: '100%'
  },
  feed: {
    padding: '10px 20px 0'
  },
  spinner: {
    fontSize: '25px'
  }
}

export default styles
